import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/servicePage.js";

// Sections for this page
import PriceListing from "./Sections/PriceListing";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function WaxPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const items = [
    {name: "Half Arms", price: "$12"},
    {name: "Full Arms", price: "$18"},
    {name: "Under Arms", price: "$8"},
    {name: "Half Upper Legs", price: "$20"},
    {name: "Half Lower Legs", price: "$15"},
    {name: "Full Legs", price: "$30"},
    {name: "Bikini Line", price: "$10"},
    {name: "Deep Bikini", price: "$20"},
    {name: "Brazilian", price: "$30"},
    {name: "Stomach", price: "$10"},
    {name: "Full Back", price: "$15"},
    {name: "Full Chest", price: "$15"},
    {name: "Full Body", price: "$125"}
  ]
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="Lili's Waxing and Threading Studio"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/wax.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Waxing</h1>
              <h4>
                Waxing leaves your skin smooth, fresh, and clean for as long as 3 weeks, a lot longer than shaving.
                Waxing also removes dead skin cells from your skin making it smooth and even.
                We have a variety of fresh waxes to choose from in one of our clean, comfortable rooms.
              </h4>
              <br />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <PriceListing products={items}/>
        </div>
      </div>
      <Footer />
    </div>
  );
}
